import { Button, CloseButton, Group, Paper, Text } from "@mantine/core";
import { observer } from "mobx-react";
import { useStores } from "@/hooks/useStores";

interface SignInPromptProps {
    /** One short line, for the player */
    compact?: boolean;
}

/**
 * Tells a signed-out listener that where they are in episodes is only remembered when signed in.
 * Shown only where sign-in is switched on, and until it is closed.
 */
export const SignInPrompt = observer(({ compact = false }: SignInPromptProps) => {
    const { appStore, authStore } = useStores();

    if (!appStore.signInEnabled || authStore.status !== "anonymous" || appStore.signInPromptDismissed) {
        return null;
    }

    const open = () => appStore.setShowSignIn(true);

    if (compact) {
        return (
            <Group gap="xs" wrap="nowrap">
                <Text c="dimmed" size="xs">
                    Logga in för att fortsätta på alla dina enheter
                </Text>
                <Button onClick={open} size="compact-xs" variant="subtle">
                    Logga in
                </Button>
            </Group>
        );
    }

    return (
        <Paper
            aria-label="Logga in för att synka mellan enheter"
            component="section"
            mb="lg"
            p="md"
            radius="md"
            withBorder>
            <Group justify="space-between" wrap="nowrap">
                <Text>
                    Logga in så följer din plats i avsnitten med dig, och du kan fortsätta lyssna på alla dina enheter.
                </Text>
                <Group gap="xs" wrap="nowrap">
                    <Button color="teal" onClick={open} variant="light">
                        Logga in
                    </Button>
                    <CloseButton aria-label="Stäng" onClick={() => appStore.dismissSignInPrompt()} />
                </Group>
            </Group>
        </Paper>
    );
});
